var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, styled, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { allCategories } from "../../util/categorias";
var StyledTabs = styled(function (props) { return (_jsx(Tabs, __assign({}, props, { TabIndicatorProps: { children: _jsx("span", { className: "MuiTabs-indicatorSpan" }) } }))); })({
    "& .MuiTabs-indicator": {
        display: "flex",
        justifyContent: "center",
        backgroundColor: "transparent",
    },
    "& .MuiTabs-indicatorSpan": {
        maxWidth: 80,
        width: "100%",
        backgroundColor: "white",
    },
});
var StyledTab = styled(function (props) { return (_jsx(Tab, __assign({ disableRipple: true }, props))); })(function () { return ({
    color: "white",
    "&.Mui-selected": {
        color: "white",
    },
}); });
export var HomeTabs = function (_a) {
    var selectedCategory = _a.selectedCategory, changeCategory = _a.changeCategory;
    var _b = useState(selectedCategory), value = _b[0], setValue = _b[1];
    useEffect(function () {
        setValue(selectedCategory);
    }, [selectedCategory]);
    var handleChange = function (event, newValue) {
        setValue(newValue);
        changeCategory(newValue);
    };
    return (_jsx(Box, __assign({ sx: {
            width: "100%",
            display: "flex",
            justifyContent: "center",
        } }, { children: _jsx(StyledTabs, __assign({ value: value, onChange: handleChange, "aria-label": "home tabs" }, { children: allCategories.map(function (category) { return (_jsx(StyledTab, { label: category.title }, category.id)); }) })) })));
};
